import { FormEvent, useContext, useEffect, useState } from 'react'
import { BiTrophy } from 'react-icons/bi'
import { toast } from 'react-toastify'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { conquistaResposta } from '../../interfaces/conquista'
import { listarConquistas } from '../../services/conquistas'
import visualizarIcon from '../../assets/img/visualizarIcon.png'
import Permissao from '../../middleware/Permissoes'
import Organizacao from '../../middleware/Organizacao'
import DivSituacao from '../DivSituacao'
import FiltrosDefault from '../FiltrosDefault'
import ModalConquista from '../ModalConquista'
import ModalNivelConquista from '../ModalNiveisConquista'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import '../../styles/paginaListaDados.css'

function Conquistas() {

    const { modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)
    const [situacao, setSituacao] = useState("")
    const [processando, setProcessando] = useState(false)
    const [titulo, setTitulo] = useState("")
    const [conquistas, setConquistas] = useState<conquistaResposta[]>([])
    const [conquistaSelecionada, setConquistaSelecionada] = useState<conquistaResposta>()

    const abrirModalAtualizar = (conquista: conquistaResposta) => {
        setConquistaSelecionada(conquista)
        modalExibir("ModalConquista")
    }

    const abrirModalCadastrar = () => {
        setConquistaSelecionada(undefined)
        modalExibir("ModalConquista")
    }

    const abrirModalVisualizarConquistas = (conquista: conquistaResposta) => {
        setConquistaSelecionada(conquista)
        modalExibir("ModalNiveisConquista")
    }

    const buscarConquistas = async (e?: FormEvent) => {
        
        e?.preventDefault()

        setProcessando(true)

        try {
            const payload = {
                titulo,
                situacao
            }

            const resposta = await listarConquistas(payload)

            setConquistas(resposta.data)

            if (conquistaSelecionada) {
                const conquistaAtualizada = resposta.data.find(
                    (conquista: conquistaResposta) =>
                        conquista.id === conquistaSelecionada.id
                )

                setConquistaSelecionada(conquistaAtualizada)
            }

        } catch {
            toast.error("Erro ao listar as Conquistas")
        } finally {
            setProcessando(false)
        }
    }

    useEffect(() => {
        buscarConquistas()
    }, [atualizarInformacoes])

    return (
        <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
            <Permissao permissoes={['master', 'conquistas_conquista']}>
                <div id='paginaContainer'>
                    {modal.nome === "ModalConquista" && <ModalConquista conquista={conquistaSelecionada} />}
                    {modal.nome === "ModalNiveisConquista" && <ModalNivelConquista conquista={conquistaSelecionada} />}
                    {conquistas.length === 0 && <NenhumResultadoEncontrado />}
                    <FiltrosDefault termo={titulo} situacao={situacao} placeholder='Pesquise pelo titulo' tipo={'Conquista'} onChangeTermo={(e) => setTitulo(e.target.value)} onChangeSituacao={(e) => setSituacao(e.target.value)} onSubmit={buscarConquistas} acaoBtn={abrirModalCadastrar} listaSituacao={[{ nome: 'Todas', valor: '' }, { nome: 'Ativas', valor: 'ativa' }, { nome: 'Inativas', valor: 'inativa' }]} genero='feminino' maisFiltros={false} acaoMaisFiltro={() => { }} isLoading={processando} />
                    <section id='fundoContainerPagina'>
                        <table id='tabelaListaContainer'>
                            <thead>
                                <tr>
                                    <th id='ladoEsquerdoContent' align='left'>Avatar</th>
                                    <th align='left'>Título</th>
                                    <th align='left'>Descrição</th>
                                    <th align='center'>Níveis</th>
                                    <th align='center'>Situação</th>
                                    <th>Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {conquistas.map((conquista) => (
                                    <tr key={conquista.id}>
                                        <td className='primeiraColuna' onClick={() => abrirModalAtualizar(conquista)}>
                                            {conquista?.avatar ? <img className='usuarioResponsavel' src={conquista.avatar} alt='' /> : <BiTrophy size={32} />}
                                        </td>
                                        <td align='left' onClick={() => abrirModalAtualizar(conquista)}>{conquista.titulo}</td>
                                        <td align='justify' onClick={() => abrirModalAtualizar(conquista)}>{conquista.descricao}</td>
                                        <td align='center' onClick={() => abrirModalAtualizar(conquista)}>{conquista?.conquistaNivels?.length}</td>
                                        <td align='center' onClick={() => abrirModalAtualizar(conquista)}>
                                            <DivSituacao texto={`${conquista.situacao.charAt(0).toUpperCase()}${conquista.situacao.substring(1)}`} cor={conquista.situacao.toLowerCase()} />
                                        </td>
                                        <td id='ladoDireitoContent' align='center' onClick={() => abrirModalVisualizarConquistas(conquista)}>
                                            <img className='apagarIconeItemTabela' title='Visualizar Conquista' src={visualizarIcon} alt='' />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section>
                </div>
            </Permissao>
        </Organizacao>
    )
}

export default Conquistas